import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import {
  StandardDialog,
} from '@roc/ui';
import { useDocumentStore } from '../../../hooks/useDocumentStore';

import { PointsOfContactsTable } from './PointOfContactTable'
import { makeStyles } from '@material-ui/core/styles';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface PointOfContactDialogProps {
  open: boolean;
  onClose: () => void;
  document: Document;
  type?: string
}

const useStyles = makeStyles(() => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: 24,
    marginTop: 24
  },
}));

export const PointOfContactDialog = observer(({ open, onClose, document, type }: PointOfContactDialogProps) => {
  const classes = useStyles();
  const {
    documentStore: { documentFormStore },
  } = useDocumentStore();
  const { pointOfContactStore } = documentFormStore;
  const taskId = document?.taskId;

  useEffect(() => {
    return () => pointOfContactStore.resetStore();
  }, [])


  const getContent = () => <PointsOfContactsTable
    type={type}
    emptyMessage='No point of contact'
    store={pointOfContactStore} />;


  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Point of Contact"
          handleClose={onClose}
          dialogContent={getContent()}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Point of Contact"
          maxWidth={
            'lg'
          }
          handleClose={onClose}
          dialogContent={getContent()}
        />
      )}
    </>
  )
});
